module.exports = __webpack_public_path__ + "img/question-mark.22a7e542.png";